/* unplugin-vue-components disabled */import { render } from "./FooterPCM.vue?vue&type=template&id=66992ba3&scoped=true"
import script from "./FooterPCM.vue?vue&type=script&lang=js"
export * from "./FooterPCM.vue?vue&type=script&lang=js"

import "./FooterPCM.vue?vue&type=style&index=0&id=66992ba3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66992ba3"]])

export default __exports__